define.alias("ember-functions-as-helper-polyfill/initializers/install-function-helper-manager", "preview-grid/initializers/install-function-helper-manager");